export enum FormKeysEnum {
    Ampm = 'ampm',
    Hours = 'hours',
    MonthDay = 'monthDay',
    WeekDay = 'weekDay',
}
